export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Final2_11.b8b81b63.jpg";